module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day03_07_stay-f687d0fc921d72579c74603e883b2e67.jpg";